import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import styled from "styled-components"

const StyledJobsSection = styled.section`
  .inner {
    display: flex;

    @media (max-width: 600px) {
      display: block;
    }

    // Prevent container from jumping
    @media (min-width: 700px) {
      min-height: 340px;
    }
  }
`

const StyledTabList = styled.div`
  position: relative;
  z-index: 3;
  width: max-content;
  padding: 0;
  margin: 0;
  list-style: none;

  @media (max-width: 600px) {
    display: flex;
    overflow-x: auto;
    width: calc(100% + 100px);
    padding-left: 50px;
    margin-left: -50px;
    margin-bottom: 30px;
  }
  @media (max-width: 480px) {
    width: calc(100% + 50px);
    padding-left: 25px;
    margin-left: -25px;
  }

  li {
    &:first-of-type {
      @media (max-width: 600px) {
        margin-left: 50px;
      }
      @media (max-width: 480px) {
        margin-left: 25px;
      }
    }
    &:last-of-type {
      @media (max-width: 600px) {
        padding-right: 50px;
      }
      @media (max-width: 480px) {
        padding-right: 25px;
      }
    }
  }
`

const StyledTabButton = styled.button`
  display: inline-block;
  text-decoration: none;
  text-decoration-skip-ink: auto;
  color: inherit;
  position: relative;
  transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: flex;
  align-items: center;
  color: #ccd6f6;
  width: 100%;
  height: 40px;
  padding: 0 16px 2px;
  border-left: 1px solid #05d9e8;
  background-color: transparent;
  font-size: 16px;
  text-align: left;
  white-space: nowrap;
  &:hover,
  &:active,
  &:focus {
    color: #ff2a6d;
    outline: 0;
  }

  @media (max-width: 768px) {
    padding: 0 16px 4px;
  }
  @media (max-width: 600px) {
    min-width: 120px;
    padding: 0 16px;
    border-left: 0;
    text-align: center;
  }
  &:hover,
  &:focus {
    color: #ff2a6d;
    transform: translateY(-3px);
  }
  .active-btn {
    color: #ff2a6d;
  }
`

const StyledTabPanels = styled.div`
  position: relative;
  width: 100%;
  margin-left: 16px;
  @media (max-width: 600px) {
    margin-left: 0;
  }

  .job-date {
    color: #d1f7ff;
    font-size: 16px;
    margin-bottom: 24px;
  }
  .job-desc {
    min-width: 100%;
    font-size: 16px;
    color: #e6f1ff;
  }
`

const query = graphql`
  {
    allStrapiJobs {
      nodes {
        company
        date
        position
        desc {
          name
          id
        }
      }
    }
  }
`

const Jobs = () => {
  const data = useStaticQuery(query)
  const {
    allStrapiJobs: { nodes: jobs },
  } = data
  const [value, setValue] = React.useState(0)
  const { position, date, desc } = jobs[value]

  return (
    <StyledJobsSection id="jobs">
      <h2 className="numbered-heading">Where I’ve Studied</h2>
      <div className="inner">
        <StyledTabList>
          {jobs.map((item, index) => {
            return (
              <div
                key={index}
                className={index === value ? "job-btn active-btn" : "job-btn"}
                onClick={() => setValue(index)}
              >
                <StyledTabButton key={item.company}>
                  {" "}
                  {item.company}{" "}
                </StyledTabButton>
              </div>
            )
          })}
        </StyledTabList>

        <StyledTabPanels>
          <h4>{position}</h4>
          <p className="job-date">{date}</p>
          {desc.map(item => {
            return (
              <ul key={item.id} className="job-desc">
                <p>{item.name} </p>
              </ul>
            )
          })}
        </StyledTabPanels>
      </div>
    </StyledJobsSection>
  )
}

export default Jobs
